<template lang="pug">
    label.label.checkbox.is-unselectable(:class="className")
        input(type="checkbox" :checked="value" :disabled="disabled" :name="name" @change="onChange")
        .checkmark(:class="classMarkName")
        span {{ title }}
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "name",
    },
    className: {
      type: String,
      default: "",
    },
    classMarkName: {
      type: String,
      default: "",
    },
  },

  methods: {
    onChange(e) {
      if (this.disabled) return;
      this.$emit("input", e.target.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  color: $defaultColor;
  &.checkbox {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 0.7rem 1rem;
    background-color: #313c44;
    border-radius: 5px;

    [type="checkbox"] {
      display: none;

      &:checked {
        & + .checkmark {
          &::after {
            content: "✓";
          }
        }
      }
    }

    .checkmark {
      position: relative;
      display: block;
      width: 1rem;
      height: 1rem;
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      &.big {
        width: 1.3rem;
        height: 1.3rem;
        border: solid 0.5px #fff;
        &::after {
          top: -0.7rem;
          left: -0.2rem;
          font-size: 2rem;
          color: #49e338;
        }
      }
      &.white {
        background-color: #ffffff;
        border: solid 0.5px #000000;
      }
      &::after {
        content: "";
        position: absolute;
        top: -0.2rem;
        left: 0.1rem;
      }

      & + span {
        &:not(:empty) {
          margin-left: 0.3rem;
        }
      }
    }
  }
  &.mini {
    padding: 0.1rem 0.7rem;
    background-color: transparent;
  }
  &.white {
    color: #313c44 !important;
    font-weight: 400;
  }
}
</style>
